<template>
  <div>
    <div class="banner">
      <div class="nav-top">
        <div class="w">
          <HeadNav activeIndex="1" textColor="#fff" color="#fff"></HeadNav>
        </div>
      </div>
      <el-carousel indicator-position="outside" arrow="never">
        <el-carousel-item v-for="item in 1" :key="item"> </el-carousel-item>
      </el-carousel>
    </div>
    <div class="w">
      <div class="title flex column justify-content align-items">
        <div>多种场景&nbsp;&nbsp;&nbsp;&nbsp;专业全面</div>
        <div class="border"></div>
      </div>
      <div class="flex space-between list">
        <div class="content-left">
          <div class="title-top flex align-items">
            <img src="../assets/sc_icon.png" alt="" class="icon" />
            <span>市场调研</span>
          </div>
          <div
            class="flex space-between content-bottom"
            style="margin-top: 55px"
          >
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>餐饮市场调查</span>
            </div>
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>培训市场调查</span>
            </div>
          </div>
          <div class="flex space-between content-bottom">
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>APP市场调查</span>
            </div>
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>手机市场调查</span>
            </div>
          </div>
          <div class="flex space-between content-bottom" style="width: 370px">
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>消费者调查</span>
            </div>
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>女性消费者偏好调查</span>
            </div>
          </div>
        </div>
        <div class="content-right">
          <img src="../assets/fc.png" alt="" />
        </div>
      </div>
      <div class="flex space-between list">
        <div class="content-right">
          <img src="../assets/xs_pic.png" alt="" />
        </div>
        <div class="content-left" style="margin-left: 115px">
          <div class="title-top flex align-items">
            <img src="../assets/xs_icon.png" alt="" class="icon" />
            <span>学术调研</span>
          </div>
          <div
            class="flex space-between content-bottom"
            style="margin-top: 55px"
          >
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>餐饮市场调查</span>
            </div>
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>培训市场调查</span>
            </div>
          </div>
          <div class="flex space-between content-bottom">
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>APP市场调查</span>
            </div>
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>手机市场调查</span>
            </div>
          </div>
          <div class="flex space-between content-bottom" style="width: 370px">
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>消费者调查</span>
            </div>
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>女性消费者偏好调查</span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex space-between list">
        <div class="content-left">
          <div class="title-top flex align-items">
            <img src="../assets/xf_icon.png" alt="" class="icon" />
            <span>消费者调研</span>
          </div>
          <div
            class="flex space-between content-bottom"
            style="margin-top: 55px"
          >
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>餐饮市场调查</span>
            </div>
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>培训市场调查</span>
            </div>
          </div>
          <div class="flex space-between content-bottom">
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>APP市场调查</span>
            </div>
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>手机市场调查</span>
            </div>
          </div>
          <div class="flex space-between content-bottom" style="width: 370px">
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>消费者调查</span>
            </div>
            <div class="flex align-items content-bottom-list">
              <img src="../assets/dian_icon.png" alt="" />
              <span>女性消费者偏好调查</span>
            </div>
          </div>
        </div>
        <div class="content-right">
          <img src="../assets/xf_pic.png" alt="" />
        </div>
      </div>

      <div class="title flex column justify-content align-items">
        <div>精选模板&nbsp;&nbsp;&nbsp;&nbsp;直接引用</div>
        <div class="border"></div>
      </div>

      <div class="swiper-box">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide>
            <img src="../assets/nzh_pic.png" />
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/yg_pic.png" />
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/wm_pic.png" />
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/yg.png" />
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-pagination" slot="pagination"></div>
          <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
          <!-- <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
        <div class="flex justify-content more">
          <p style="color: #0080ff" @click="jumpTemplate()">查看更多模板>></p>
          <!-- <router-link to="template" style="color: #0080ff">查看更多模板>></router-link> -->
        </div>
      </div>
    </div>
    <div class="img-box">
      <div class="w" style="position: relative; height: 500px">
        <div class="img-box-small">
          <div>
            <div style="height: 50px; margin-top: 25px">
              <span class="abouts">关于我们</span>
              <div class="border" style="margin-left: 20px; width: 130px"></div>
            </div>
            <div style="height: 130px; width: 1145px; margin: 0 auto">
               <p class="aboutus_text">
                AI Learning
                是一家通过ISO9001质量体系认证的国家高新技术企业，具有涉外调查资质；北京大数据协会副会长、副秘书长单位；中国商业统计学会常务理事单位、市场调查与教学研究分会常务理事副秘书长单位、数据科学与商业智能分会常务理事副秘书长单位；全国工业统计学教学研究会常务理事单位、青年统计学家协会创始常务理事单位、健康医疗大数据学会理事单位；中国现场统计研究会统计综合评价研究分会常务理事单位、经济与金融统计分会常务理事单位、大数据统计分会理事单位；中国市场信息调查业协会第三方评估委员会创始单位。
              </p> 
              <p class="aboutus_text">
                公司深耕市场调研、大数据与人工智能10余年，是以提供调研、数据资源、AI数据建模服务、教学科研平台为核心业务的行业大数据和人工智能平台及解决方案提供商。主要产品系列有：“东方神采”数据采集平台、“东方神灯”大数据分析挖掘平台、“东方神画”大数据可视化平台、“东方神评”专家评审平台、“东方神策”消费环境监测与评价系统、“AI实验室”、“AI云课堂”、AI学科竞赛云平台、“东方爱学”大数据资源平台、“AI学”大数据综合实践云平台、“AI研”大数据科研平台、“AI创新创业孵化平台”等。
              </p> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w" style="margin-top: 280px">
      <div class="title flex column justify-content align-items">
        <div>我们的优势</div>
        <div class="border"></div>
      </div>
      <div class="card1">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="flex column align-items justify-content">
              <div class="slide">
                <img src="../assets/zy_icon.png" alt="" />
              </div>
              <div style="font-size: 26px; margin-top: 20px">专业</div>
              <div style="font-size: 20px; margin-top: 10px">
                专业的调查服务、研究报告
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex column align-items justify-content">
              <div class="slide">
                <img src="../assets/cb_icon.png" alt="" />
              </div>
              <div style="font-size: 26px; margin-top: 20px">低成本</div>
              <div
                style="
                  font-size: 20px;
                  margin-top: 10px;
                  text-align: center;
                  width: 70%;
                "
              >
                提供不同场景的专业调查 模板、题库减少设计问卷成本
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex column align-items justify-content">
              <div class="slide">
                <img src="../assets/xl_icon.png" alt="" />
              </div>
              <div style="font-size: 26px; margin-top: 20px">高效率</div>
              <div
                style="
                  font-size: 20px;
                  margin-top: 10px;
                  text-align: center;
                  width: 70%;
                "
              >
                多终端多场景链接用户 多种质控手段保证数据真实有效
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <HeadFooter></HeadFooter>
  </div>
</template>
<script>
import HeadNav from "@/components/HeadNav";
import HeadFooter from "@/components/HeadFooter";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "Index",
  components: {
    HeadFooter,
    HeadNav,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        //循环模式开启
        loop: true,
        slidesPerView: 4,
        spaceBetween: 30,
        speed: 300,
        autoplayDisableOnInteraction: false,
        //自动切换
        autoplay: 1000,
        // navigation: {
        //   //使用前进后退按钮来控制Swiper切换
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev"
        // },
        // prevButton:'.swiper-button-prev',
        // nextButton:'.swiper-button-next',
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  methods: {
		language() {
			return window.localStorage.getItem('lang') || this.$defaultLang
		},
    jumpTemplate() {
      this.$router.push("/template");
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    caslogin(ticket) {
      let that = this;
      this.$axios({
        method: "GET",
        url: this.$config.service.caslogin + "?ticket=" + ticket,
        'Accept-Language': this.language(),
      })
        .then((response) => {
          if (response.data.code == 0) {
            let userInfo = JSON.stringify(response.data.resultBody);
            window.localStorage.setItem("userInfo", userInfo);
            window.localStorage.setItem(
              "token",
              response.data.resultBody.token
            );
            this.$message.success("登录成功");
            window.location.href = "/";
          } else if (res.code == 1001) {
            window.location.href =
              VUE_APP_CAS_BASE_URL +
              "/login?service=" +
              VUE_APP_CAS_BACKSERVICE_URL;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    // 判断用户是否登录
    /*alert(this.$route.meta.requireAuth);
    if(localStorage.getItem('token') == null && window.ssoswitch == "on"){
      let ticket = this.getQueryString("ticket");
      if(ticket == null){
        this.$message.error("票据信息验证失败！");
        window.location.href = VUE_APP_CAS_BASE_URL + "/login?service=" + VUE_APP_CAS_BACKSERVICE_URL
      }
      this.caslogin(ticket);
    }*/
  },
};
</script>

<style scoped>
.slide:hover {
  margin-top: -5px;
}
.el-carousel__container {
  height: 100%;
}
.el-carousel__arrow i {
  display: none !important;
}
.el-carousel__item:nth-child(1) {
  background: url("../assets/banner.png") no-repeat center;
}
.el-carousel__indicators--outside {
  display: none;
}
.el-carousel {
  height: 100%;
}
.content-left {
  width: 50%;
}
.banner {
  /* height: 600px; */
  height: 340px;
  width: 100%;
  position: relative;
}
.banner-font {
  position: absolute;
  left: 30%;
  top: 40%;
}
.card1 {
  margin-top: 60px;
}
.nav-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
}
.title {
  font-size: 26px;
  color: #333;
  margin-top: 40px;
}
.border {
  width: 80px;
  height: 5px;
  border-radius: 5px;
  background: #0080ff;
  margin-top: 15px;
}
.title-top {
  font-size: 24px;
  color: #333;
  margin-left: 30px;
  margin-top: 100px;
}
.content-right {
  width: 50%;
}
.content-right img {
  width: 665px;
}
.content-bottom {
  width: 315px;
  font-size: 18px;
  color: #666;
  margin-left: 88px;
  flex-shrink: 0;
}
.content-bottom span {
  margin-left: 10px;
}
.content-bottom-list {
  margin-bottom: 25px;
}
.content-bottom-list img {
  margin-top: 5px;
}
.list {
  margin-top: 50px;
}
.icon {
  width: 46px;
  height: 46px;
  margin-right: 20px;
}
.swiper-box {
  margin-top: 40px;
}
.swiper-slide img {
  width: 100%;
}
.swiper-slide {
  width: 286px;
}
.swiper-container {
  height: 490px;
}
.more {
  font-size: 14px;
  color: #0080ff;
  margin-top: 40px;
  cursor: pointer;
}
.img-box {
  width: 100%;
  height: 500px;
  margin-top: 85px;
  background: url("../assets/banner2.png") no-repeat center;
}
.img-box-small {
  width: 100%;
  height: 360px;
  /* height: 260px; */
  background: #fff;
  position: absolute;
  left: 0;
  top: 400px;
  box-shadow: 1px 3px 17px -5px #aeaeae;
}
.img-box-small p {
  /* font-size: 16px; */
  color: #333;
}

.aboutus_text {
  width: 1145px;
  /* height: 140px; */
  line-height: 35px;
  letter-spacing: 1px;
  font-size: 18px;
  color: #333333;
  margin-top: 0;
  font-family: "Microsoft YaHei";
  line-height: 1.5;
  text-indent: 2em;
}
.border {
  width: 64px;
  height: 4px;
  float: left;
  margin-left: 0px;
}
.abouts {
  font-size: 26px;
  margin-left: 35px;
  float: left;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0px solid #409eff;
  color: #333;
  position: relative;
}
</style>
